import { render, staticRenderFns } from "./DialogSceltaSottoDirectory.vue?vue&type=template&id=21e29002&"
import script from "./DialogSceltaSottoDirectory.vue?vue&type=script&lang=js&"
export * from "./DialogSceltaSottoDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports